import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import { PenTool } from "react-feather";

//Forms
import UpdateClusterForm from "./UpdateClusterForm";

interface UpdateModalProps {
  id: number;
}

const UpdateClusterModal = ({ id }: UpdateModalProps) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn
        className="px-2"
        color="primary"
        onClick={toggle}
        style={{ display: "flex", alignItems: "center", gap: "2px" }}
        size="sm"
      >
        <PenTool size={16} />
        Update
      </Btn>
      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update Cluster</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Fill in the details below.
            </P>
          </ModalHeader>
          <UpdateClusterForm toggle={toggle} cluster_id={id} />
        </div>
      </Modal>
    </>
  );
};
export default UpdateClusterModal;
